export function logError(error: string) {
  if (process.env.NODE_ENV === 'test') {
    return
  }
  console.log(`Obvio Embed: ${error}`)
}
